import getLangLocale from 'I18n/utils/getLangLocale';
import { getPreferredLanguage } from 'pricing-pages-lib/utils/getPreferredLanguage';
import { getBrowserLocaleOverride, getCountryCodeOverride } from 'pricing-pages-ui-components/utils/debugOverrides';
export const getBrowserLocale = () => {
  const browserLocale = getBrowserLocaleOverride() || getLangLocale() || getPreferredLanguage() || 'en-us';
  const preferredCountryCode = getCountryCodeOverride() || window.COUNTRY_CODE_FROM_LOCALE && window.COUNTRY_CODE_FROM_LOCALE.toUpperCase();
  return {
    browserLocale,
    preferredCountryCode
  };
};